import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'How It Works', path: '/how-it-works' },
    { name: 'Services', path: '/services' },
    { name: 'Broker Partnership', path: '/broker-partnership' },
    { name: 'Broker Training', path: '/broker-training' },
    { name: 'Submit a Deal', path: '/submit-deal' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#2F6FE4] shadow-lg' : 'bg-[#2F6FE4]/95'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-2">
            <span
              style={{ color: '#FFFFFF', fontWeight: 800 }}
            >
              The Broker Marketplace
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-[#555555] hover:text-[#2F6FE4] transition-colors text-sm font-medium cursor-pointer">Home</Link>
            <Link to="/how-it-works" className="text-[#555555] hover:text-[#2F6FE4] transition-colors text-sm font-medium cursor-pointer">How It Works</Link>
            <Link to="/services" className="text-[#555555] hover:text-[#2F6FE4] transition-colors text-sm font-medium cursor-pointer">Services</Link>
            <Link to="/broker-partnership" className="text-[#555555] hover:text-[#2F6FE4] transition-colors text-sm font-medium cursor-pointer">Broker Partnership</Link>
            <Link to="/broker-training" className="text-[#555555] hover:text-[#2F6FE4] transition-colors text-sm font-medium cursor-pointer">Broker Training</Link>
            <Link to="/submit-deal" className="text-[#555555] hover:text-[#2F6FE4] transition-colors text-sm font-medium cursor-pointer">Submit a Deal</Link>
            <Link to="/broker-signup" className="bg-[#2F6FE4] text-white px-6 py-2.5 rounded-lg hover:bg-[#1a5cd4] transition-colors text-sm font-semibold whitespace-nowrap cursor-pointer">Broker Sign Up</Link>
          </div>

          <button
            className="lg:hidden cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className="ri-menu-line text-2xl text-white"></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-[#2F6FE4] shadow-lg">
          <div className="px-6 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="block text-white/80 hover:text-white font-medium"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="#apply"
              className="block bg-white text-[#2F6FE4] px-6 py-2.5 rounded-full font-semibold text-center cursor-pointer hover:bg-[#A9C9FF] transition-all"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Apply Now
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;